import InputTextPR from "./InputTextPR";

export default InputTextPR;
